import React from 'react';
import styled from 'styled-components';
import { Button } from 'components';
import { DismissDialogIcon } from 'assets/svgs';

function DimissDialog({ onClick }) {
  return (
    <StyledButton color="secondary" onClick={onClick}>
      <DismissDialogIcon />
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  align-items: center;
  border-radius: 6px !important;
  display: flex;
  height: 34px;
  justify-content: center;
  min-width: unset !important;
  padding: 8px 11px !important;
  position: absolute !important;
  right: 0;
  top: 0;
  width: 40px;

  svg {
    height: 1rem;
    width: 1rem;
  }
`;

export default DimissDialog;
